import React, { useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';

interface IProps {
	settingsId: string;
	onChange: (value: string) => void;
}

const YandexChequeApiTokenField: React.FC<IProps> = ({ onChange, settingsId }) => {
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterYandexChequeApiToken') }], [t]);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const valueWithoutSpaces = e.target.value.replace(/\s/g, '');
			onChange(valueWithoutSpaces);
			return valueWithoutSpaces;
		},
		[onChange],
	);

	return (
		<FormInput
			testId="YandexChequeApiTokenField"
			name={`yandexChequeApiToken-${settingsId}`}
			label="yandexChequeApiTokenLabel"
			getValueFromEvent={handleChange}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(YandexChequeApiTokenField);
